(function () {
  /*
    GUMMY LAB — GLOBAL SUBSCRIPTION DEFAULT + BADGE SYNC

    Behaviour:
    - Product page loads -> Subscribe & Save selected by default
    - 30 / 60 / 90 Day variant change -> current purchase choice persists
    - Customer manually selects One-time -> respect their choice
    - Customer manually selects Subscription -> respect their choice
    - "Subscription" badge ONLY shows while Subscription is selected
    - Handles Shopify Subscriptions re-rendering/resetting its widget
    - Handles your custom .tg-variant__btn variant picker
    - Does NOT modify your custom variant picker
    - Safe to load globally on product pages
  */

  'use strict';

  var purchasePreference = 'selling_plan';
  var syncToken = 0;
  var reconcileTimer = null;


  /* =========================================================
     GET CURRENT VARIANT
  ========================================================= */

  function getActiveVariantId() {

    /* Gummy Lab custom variant picker */
    var active = document.querySelector(
      '.tg-variant__btn.is-active'
    );

    if (active) {
      var activeId = active.getAttribute('data-variant-id');

      if (activeId) {
        return activeId;
      }
    }


    /* Dawn/product-form fallback */
    var variantInput = document.querySelector(
      'product-info input[name="id"].product-variant-id,' +
      'product-info form[data-type="add-to-cart-form"] input[name="id"],' +
      'product-info form[action*="/cart/add"] input[name="id"]'
    );

    if (variantInput && variantInput.value) {
      return variantInput.value;
    }


    /* Shopify Subscriptions fallback */
    var oneTime = document.querySelector(
      '.plan_card input[data-radio-type="one_time_purchase"]'
    );

    if (oneTime) {
      return oneTime.getAttribute('data-variant-id');
    }


    return null;
  }


  /* =========================================================
     FIND SUBSCRIPTION CONTROLS FOR A VARIANT
  ========================================================= */

  function getControlsForVariant(variantId) {

    if (!variantId) {
      return null;
    }


    var oneTimeRadios = document.querySelectorAll(
      '.plan_card input[data-radio-type="one_time_purchase"]'
    );

    var oneTime = null;


    for (var i = 0; i < oneTimeRadios.length; i++) {

      var radioVariantId =
        oneTimeRadios[i].getAttribute('data-variant-id');

      if (
        String(radioVariantId) ===
        String(variantId)
      ) {
        oneTime = oneTimeRadios[i];
        break;
      }
    }


    if (!oneTime) {
      return null;
    }


    /*
      Shopify gives the One-time and selling-plan radios
      belonging to the same variant the same "name".
    */

    var subscriptionRadios = document.querySelectorAll(
      '.plan_card input[data-radio-type="selling_plan"]'
    );

    var subscription = null;


    for (var j = 0; j < subscriptionRadios.length; j++) {

      if (
        subscriptionRadios[j].name ===
        oneTime.name
      ) {
        subscription = subscriptionRadios[j];
        break;
      }
    }


    return {
      oneTime: oneTime,
      subscription: subscription
    };
  }


  /* =========================================================
     MAIN PRODUCT PRICE
  ========================================================= */

  function getMainPriceElement() {

    return (
      document.querySelector('product-info .price') ||
      document.querySelector('.product__info-container .price') ||
      document.querySelector('.product .price') ||
      null
    );
  }


  /* =========================================================
     SUBSCRIPTION BADGE
  ========================================================= */

  function ensureSubscriptionBadge() {

    var price = getMainPriceElement();

    if (!price) {
      return null;
    }


    var existing = price.querySelector(
      '.price__badge--subscription'
    );

    if (existing) {
      return existing;
    }


    /*
      Clone your Sale badge so Subscription automatically
      inherits your existing red/white badge styling.
    */

    var saleBadge = price.querySelector(
      '.price__badge-sale:not(.price__badge--subscription)'
    );


    var badge;


    if (saleBadge) {

      badge = saleBadge.cloneNode(true);

      badge.classList.add(
        'price__badge--subscription'
      );

      badge.textContent = 'Subscription';

      saleBadge.insertAdjacentElement(
        'afterend',
        badge
      );

    } else {

      /*
        Fallback if a product doesn't currently render
        a Sale badge.
      */

      badge = document.createElement('span');

      badge.className =
        'badge price__badge-sale color-scheme-4 price__badge--subscription';

      badge.textContent = 'Subscription';

      price.appendChild(badge);
    }


    return badge;
  }


  function syncSubscriptionBadge() {

    var variantId = getActiveVariantId();

    var controls =
      getControlsForVariant(variantId);


    /*
      IMPORTANT:

      purchasePreference is the source of truth.

      We deliberately do NOT rely on :checked alone because
      Shopify temporarily reports stale radio states while
      rebuilding its subscription widget.
    */

    var shouldShow =
      purchasePreference === 'selling_plan' &&
      controls &&
      controls.subscription;


    var price = getMainPriceElement();

    if (!price) {
      return;
    }


    var badges = price.querySelectorAll(
      '.price__badge--subscription'
    );


    /*
      Subscription selected but price HTML refresh removed
      the badge -> recreate it.
    */

    if (shouldShow && badges.length === 0) {

      ensureSubscriptionBadge();

      badges = price.querySelectorAll(
        '.price__badge--subscription'
      );
    }


    for (var i = 0; i < badges.length; i++) {

      if (shouldShow) {

        badges[i].style.setProperty(
          'display',
          'inline-block',
          'important'
        );

        badges[i].setAttribute(
          'aria-hidden',
          'false'
        );

      } else {

        badges[i].style.setProperty(
          'display',
          'none',
          'important'
        );

        badges[i].setAttribute(
          'aria-hidden',
          'true'
        );
      }
    }
  }


  /*
    Shopify can redraw the price/widget several times
    in quick succession.

    Re-check the badge at several short intervals.
  */

  function reinforceBadge() {

    syncSubscriptionBadge();

    setTimeout(syncSubscriptionBadge, 25);
    setTimeout(syncSubscriptionBadge, 75);
    setTimeout(syncSubscriptionBadge, 150);
    setTimeout(syncSubscriptionBadge, 300);
    setTimeout(syncSubscriptionBadge, 600);
  }


  /* =========================================================
     APPLY CURRENT PURCHASE PREFERENCE
  ========================================================= */

  function applyPreference(variantId) {

    var controls =
      getControlsForVariant(variantId);


    if (!controls) {
      return false;
    }


    /* -----------------------------
       SUBSCRIPTION
    ----------------------------- */

    if (purchasePreference === 'selling_plan') {

      if (!controls.subscription) {
        return false;
      }


      if (!controls.subscription.checked) {

        /*
          Actual click is intentional.

          This lets Shopify Subscriptions run its own
          selling-plan logic instead of merely changing
          the visual radio state.
        */

        controls.subscription.click();
      }


      reinforceBadge();


      return controls.subscription.checked;
    }


    /* -----------------------------
       ONE-TIME PURCHASE
    ----------------------------- */

    if (!controls.oneTime.checked) {

      controls.oneTime.click();
    }


    reinforceBadge();


    return controls.oneTime.checked;
  }


  /* =========================================================
     KEEP PURCHASE CHOICE THROUGH SHOPIFY RE-RENDERS
  ========================================================= */

  function syncVariant(variantId) {

    if (!variantId) {
      return;
    }


    var myToken = ++syncToken;

    var attempts = 0;

    /*
      Shopify sometimes performs more than one redraw.
      Keep reconciliation alive for several seconds.
    */

    var maxAttempts = 45;


    function trySync() {

      if (myToken !== syncToken) {
        return;
      }


      attempts++;


      var success =
        applyPreference(variantId);


      syncSubscriptionBadge();


      if (attempts < maxAttempts) {

        setTimeout(
          trySync,
          success ? 150 : 100
        );
      }
    }


    setTimeout(
      trySync,
      40
    );
  }


  /* =========================================================
     RECONCILE CURRENT PAGE STATE
  ========================================================= */

  function reconcileCurrentState() {

    var variantId =
      getActiveVariantId();


    if (!variantId) {

      syncSubscriptionBadge();

      return;
    }


    /*
      If Shopify has silently reset the visible selector,
      put it back onto the customer's actual preference.
    */

    var controls =
      getControlsForVariant(variantId);


    if (controls) {

      if (
        purchasePreference === 'selling_plan' &&
        controls.subscription &&
        !controls.subscription.checked
      ) {

        controls.subscription.click();

      } else if (
        purchasePreference === 'one_time_purchase' &&
        !controls.oneTime.checked
      ) {

        controls.oneTime.click();
      }
    }


    syncSubscriptionBadge();
  }


  function scheduleReconcile(delay) {

    if (reconcileTimer) {
      clearTimeout(reconcileTimer);
    }


    reconcileTimer = setTimeout(
      reconcileCurrentState,
      typeof delay === 'number' ? delay : 30
    );
  }


  /* =========================================================
     CUSTOMER MANUALLY CHANGES PURCHASE OPTION

     CLICK listener = immediate response.
     CHANGE listener = backup / confirmation.
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var target = event.target;


      if (!target) {
        return;
      }


      /* -----------------------------------------
         ONE-TIME / SUBSCRIPTION SELECTOR
      ----------------------------------------- */

      var purchaseInput = null;


      if (
        target.matches &&
        target.matches(
          '.plan_card input[data-radio-type]'
        )
      ) {

        purchaseInput = target;

      } else if (
        target.closest
      ) {

        purchaseInput =
          target.closest(
            '.plan_card input[data-radio-type]'
          );
      }


      if (purchaseInput) {

        var radioType =
          purchaseInput.getAttribute(
            'data-radio-type'
          );


        if (
          radioType ===
          'one_time_purchase'
        ) {

          purchasePreference =
            'one_time_purchase';

          /*
            Hide the badge immediately.
            Don't wait for Shopify's redraw.
          */

          reinforceBadge();


          var currentVariantOneTime =
            getActiveVariantId();


          if (currentVariantOneTime) {

            setTimeout(
              function () {

                syncVariant(
                  currentVariantOneTime
                );

              },
              20
            );
          }


          return;
        }


        if (
          radioType ===
          'selling_plan'
        ) {

          purchasePreference =
            'selling_plan';


          reinforceBadge();


          var currentVariantSubscription =
            getActiveVariantId();


          if (currentVariantSubscription) {

            setTimeout(
              function () {

                syncVariant(
                  currentVariantSubscription
                );

              },
              20
            );
          }


          return;
        }
      }


      /* -----------------------------------------
         GUMMY LAB CUSTOM VARIANT PICKER
      ----------------------------------------- */

      var button =
        target.closest
          ? target.closest(
              '.tg-variant__btn'
            )
          : null;


      if (
        !button ||
        button.disabled
      ) {
        return;
      }


      var variantId =
        button.getAttribute(
          'data-variant-id'
        );


      if (!variantId) {
        return;
      }


      /*
        Your existing variant picker handles the actual
        variant change.

        We simply wait for Shopify Subscriptions to rebuild
        its own widget for that new variant.
      */

      setTimeout(
        function () {

          syncVariant(
            variantId
          );

        },
        80
      );


      /*
        Your variant picker also refreshes the price HTML,
        so keep the badge matched to purchasePreference.
      */

      setTimeout(syncSubscriptionBadge, 100);
      setTimeout(syncSubscriptionBadge, 250);
      setTimeout(syncSubscriptionBadge, 500);
      setTimeout(syncSubscriptionBadge, 900);
      setTimeout(syncSubscriptionBadge, 1500);

    },
    false
  );


  /*
    Backup listener.

    This catches any Shopify/app interaction that changes
    the radio without going through the click path above.
  */

  document.addEventListener(
    'change',
    function (event) {

      var target = event.target;


      if (
        !target ||
        !target.matches
      ) {
        return;
      }


      if (
        target.matches(
          '.plan_card input[data-radio-type="one_time_purchase"]'
        ) &&
        target.checked
      ) {

        purchasePreference =
          'one_time_purchase';


        reinforceBadge();


        var oneTimeVariant =
          getActiveVariantId();


        if (oneTimeVariant) {

          syncVariant(
            oneTimeVariant
          );
        }


        return;
      }


      if (
        target.matches(
          '.plan_card input[data-radio-type="selling_plan"]'
        ) &&
        target.checked
      ) {

        purchasePreference =
          'selling_plan';


        reinforceBadge();


        var subscriptionVariant =
          getActiveVariantId();


        if (subscriptionVariant) {

          syncVariant(
            subscriptionVariant
          );
        }
      }

    }
  );


  /* =========================================================
     WATCH SHOPIFY SUBSCRIPTIONS + PRICE RE-RENDERS
  ========================================================= */

  var observer =
    new MutationObserver(
      function () {

        /*
          Do not trust whatever radio happens to be checked
          during the mutation.

          Instead reconcile Shopify back to our saved
          purchasePreference.
        */

        scheduleReconcile(25);
      }
    );


  /* =========================================================
     INITIAL PAGE LOAD
  ========================================================= */

  function initialiseSubscriptionDefault() {

    var root =
      document.querySelector(
        'product-info'
      ) ||
      document.body;


    if (!root) {
      return;
    }


    observer.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );


    /*
      New visitor defaults to Subscribe & Save.
    */

    purchasePreference =
      'selling_plan';


    var variantId =
      getActiveVariantId();


    if (variantId) {

      syncVariant(
        variantId
      );
    }


    /*
      Shopify's app block may arrive slightly after the rest
      of the product page.
    */

    setTimeout(
      function () {

        var id =
          getActiveVariantId();

        if (id) {
          syncVariant(id);
        }

      },
      150
    );


    setTimeout(reconcileCurrentState, 300);
    setTimeout(reconcileCurrentState, 600);
    setTimeout(reconcileCurrentState, 1000);
    setTimeout(reconcileCurrentState, 1500);
    setTimeout(reconcileCurrentState, 2500);
  }


  /* =========================================================
     SHOPIFY THEME EDITOR SUPPORT
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        function () {

          purchasePreference =
            'selling_plan';

          var variantId =
            getActiveVariantId();

          if (variantId) {
            syncVariant(variantId);
          }

        },
        100
      );
    }
  );


  /* =========================================================
     START
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseSubscriptionDefault
    );

  } else {

    initialiseSubscriptionDefault();
  }

})();